"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    inputSelectVariants: ()=>inputSelectVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const inputSelectVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        root: 'flex w-full items-center justify-between gap-2',
        labelSlot: 'text-body2',
        selectBoxWrapper: 'grid grid-cols-1 items-center',
        selectBox: [
            'relative col-start-1 row-start-1 w-full appearance-none py-2 pl-4 pr-8',
            'border-primary-6 rounded-xl border',
            'focus-visible:outline-primary-8 focus-visible:shadow-input-focus',
            'hover:border-primary-10 hover:shadow-input-hover hover:cursor-pointer'
        ],
        dropdownIcon: 'pointer-events-none col-start-1 row-start-1 mr-2 self-center justify-self-end'
    },
    variants: {
        size: {
            sm: {
                selectBox: 'text-body3 h-[32px]'
            },
            md: {
                selectBox: 'h-[48px]'
            },
            lg: {
                selectBox: 'text-body1 h-[56px]'
            }
        }
    },
    defaultVariants: {
        size: 'md'
    }
});
exports.inputSelectVariants = __webpack_exports__.inputSelectVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "inputSelectVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
